import { MessageComponent } from '../../components/message';

export const ClaimedPrize = () => {
  return <MessageComponent message={'THANK YOU FOR CLAIMING YOUR PRIZE'} />;
};
